// extracted by mini-css-extract-plugin
export default {"imgdiv":"_61e18bfc60 c6076708b8","img":"_837a06e369 _7ea5211427"};